import { ReactNode, useMemo, useState } from "react";
import { Card } from "react-bootstrap";
import useGetTableData from "../../hook/useGetTableData";
import TableTemplate from "../component/table-pagination";
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from "../utils/Constant";
import SignatureModal from "./components/signature-modal";
import SignatureFilter from "./components/SignatureFilter";
import { SIGNATURE_COLUMNS } from "./constants/columns";
import { getSignatures } from "./services";

type ColumnActionType = "viewSignatureForm";

const Patients = () => {
	const { query, setQuery, data } = useGetTableData({
		fetchApi: getSignatures,
		initialQuery: {
			pageIndex: DEFAULT_PAGE_INDEX,
			pageSize: DEFAULT_PAGE_SIZE,
		},
	});
	const [dynamicComponent, setDynamicComponent] = useState<{
		key: string;
		data: any;
	}>({
		key: "",
		data: null,
	});

	const onModalClose = () => {
		setDynamicComponent({
			key: "",
			data: null,
		});
	};

	const onActionButtonClick = (rowData: any, actionType: ColumnActionType) => {
		setDynamicComponent({
			key: actionType,
			data: rowData,
		});
	};

	const DynamicComponent = useMemo(() => {
		const componentMap: Record<ColumnActionType, ReactNode> = {
			viewSignatureForm: <SignatureModal open onClose={onModalClose} />,
		};
		return componentMap[dynamicComponent.key as keyof typeof componentMap];
	}, [dynamicComponent.key]);

	return (
		<Card className="p-3">
			<SignatureFilter
				onSearch={(params) => {
					setQuery({
						...query,
						...params,
						pageIndex: DEFAULT_PAGE_INDEX,
					});
				}}
			/>
			<TableTemplate
				data={data?.admissions?.content ?? []}
				columns={SIGNATURE_COLUMNS}
				paging={{
					totalPages: data?.admissions?.totalPages ?? 0,
					totalElements: data?.admissions?.totalElements ?? 0,
					numberOfElements: data?.admissions?.numberOfElements ?? 0,
				}}
				selectable
				tableClassname="h-calc-vh-200"
				onPagingChange={(page, size) => {
					if (page !== query?.pageIndex || size !== query?.pageSize) {
						setQuery({
							...query,
							pageIndex: page,
							pageSize: size,
						});
					}
				}}
				tableOptions={{
					onActionButtonClick,
				}}
			/>
			{dynamicComponent.key && DynamicComponent}
		</Card>
	);
};

export default Patients;
